const getMarkup = (markup) => {return {__html: markup};}

export default getMarkup 